import { render } from "./DoctorsListTemplate3.vue?vue&type=template&id=064b0bac&scoped=true"
import script from "./DoctorsListTemplate3.vue?vue&type=script&lang=ts"
export * from "./DoctorsListTemplate3.vue?vue&type=script&lang=ts"

import "./DoctorsListTemplate3.vue?vue&type=style&index=0&id=064b0bac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-064b0bac"

export default script